import React from 'react';
import styled from '@emotion/styled';
import PageHero from 'components/PageHero';

const Wrapper = styled.div`
  padding: 40px 10px;
  display: flex;
`;

const StyledLink = styled.a`
  color: black;
  text-decoration: underline;
  font-size: 18px;
  margin: auto;
`;

const Personuppgiftspolicy = () => {
  return (
    <>
      <PageHero
        title="Digitos Personuppgiftspolicy"
        text="Information om behandling av personuppgifter"
      />
      <Wrapper>
        <StyledLink
          href={'/files/personuppgiftspolicy.pdf'}
          target="_blank"
          rel="noreferrer"
        >
          Personuppgiftspolicy.pdf
        </StyledLink>
      </Wrapper>
    </>
  );
};

Personuppgiftspolicy.layoutOptions = {
  backgroundColor: '#e9d3b8',
  footer: true,
  noBottomSpacing: true
};

export default Personuppgiftspolicy;
